export enum AccessLevel {
  Owner = 1000,
  Admin = 100,
  Editor = 10,
  // Viewer = 1,
}
